/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />

namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PaymentDetailsDialog extends _Ext.EditorDialogBase<PaymentDetailsRow> {
        protected getFormKey() { return PaymentDetailsForm.formKey; }
        protected getLocalTextPrefix() { return PaymentDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return PaymentDetailsRow.deletePermission; }
        protected getInsertPermission() { return PaymentDetailsRow.insertPermission; }
        protected getUpdatePermission() { return PaymentDetailsRow.updatePermission; }
        public static lock: boolean;  
        protected form = new PaymentDetailsForm(this.idPrefix);
        public exchangerate;
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.ExchangeRate);
            q.showAndDisableField(this.form.Mode);
            this.form.LedgerId.changeSelect2(e => {
                if (this.form.LedgerId.value == "1001") {
                    this.form.Mode.value = "Cash";
                    q.hideField(this.form.ChequeDate);
                    q.hideField(this.form.ChequeNo);
                    q.hideField(this.form.RefNo);
                    q.HideCategoryLable(this.element);
                }
                else {
                    this.form.Mode.value = "Cheque";
                    q.ShowCategoryLable(this.element);
                    q.showAndSetRequiredField(this.form.ChequeDate);
                    q.showAndSetRequiredField(this.form.ChequeNo);
                    q.showAndSetRequiredField(this.form.RefNo);
                }
            }); 
        }

        protected onDialogOpen() {
            super.onDialogOpen();
            var ledgerId = parseInt((this.parentEditor.parentDialog as PaymentDialog).form.LedgerId.value);
            var currencyid = parseInt((this.parentEditor.parentDialog as PaymentDialog).form.CurrencyId.value);
            if (currencyid == undefined) {
                Q.alert('Please Select Currency'); 
                this.dialogClose();
                return;
            } else {
                this.form.ExchangeRate.value = (this.parentEditor.parentDialog as PaymentDialog).form.ExchangeRate.value;
                q.showAndDisableField(this.form.ExchangeRate);
            }
            if (ledgerId == undefined || ledgerId == 0) {
                Q.alert('Please Select Party'); 
                this.dialogClose();
                return;
            }
            var checkknockoff = (this.parentEditor.parentDialog as PaymentDialog).form.KnockOffTotal.value > 0 ? true : false;
            if (checkknockoff) {
                //this.element.find('.tool-buttons').attr("style", "display:none;");
                //this.element.find('.s-DialogToolbar').attr("style", "display:none;");
                //this.element.find('.s-Toolbar').attr("style", "display:none;");
                //this.element.find('.clearfix').attr("style", "display:none;");
                q.HideDialogToolbar(this.element);
                q.showAndDisableField(this.form.Mode);
                q.showAndDisableField(this.form.ChequeDate);

                q.showAndDisableField(this.form.ChequeNo);
                q.showAndDisableField(this.form.Amount);
                q.showAndDisableField(this.form.LedgerId);
                if (this.form.LedgerId.value == "1001") {
                    this.form.Mode.value = "Cash";
                    q.hideField(this.form.ChequeDate);
                    q.hideField(this.form.ChequeNo);
                    q.hideField(this.form.RefNo);
                    q.HideCategoryLable(this.element);
                }
                else {
                    this.form.Mode.value = "Cheque";
                    q.ShowCategoryLable(this.element);
                    q.showAndSetRequiredField(this.form.ChequeDate);
                    q.showAndSetRequiredField(this.form.ChequeNo);
                    q.showAndSetRequiredField(this.form.RefNo);
                }
            }
        }
    }
}